import { searchPages } from "@ludens-reklame/rubics-v3-sdk/page";
import { useSearch } from "../search/search.hooks.js";
export function usePageSearch(init = {}, query = {}) {
    return useSearch(searchPages, init, query);
}
